import React from 'react'
import { LeftOutlined, RightOutlined } from '@ant-design/icons'

const defaultPageStyle = {
  lineHeight: '30px',
  minWidth: '32px',
  padding: '0 6px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  margin: '0 5px',
  cursor: 'pointer'
}

const selectionnedPageStyle = {
  border: '1px solid #ff4438',
  backgroundColor: '#ffffff',
  borderRadius: '9px',
  color: '#ff4438',
  fontWeight: 'bold'
}

const unselectionnedPageStyle = {
  border: '1px solid transparent',
  borderRadius: '16px',
  '--hover-backgroundColor': 'rgba(0, 0, 0, 0.06)'
}

export default function Pagination ({ currentPage, maxPage, onChange }) {
  const MAX_LINKS = 7
  const PAGE_RANGE_DISPLAYED = (MAX_LINKS - 1) / 2

  const currentPageIsAtBeginning = currentPage <= (1 + PAGE_RANGE_DISPLAYED)
  const currentPageIsAtEnd = currentPage >= (maxPage - PAGE_RANGE_DISPLAYED)

  const head = () => {
    const displayDivider = !currentPageIsAtBeginning && maxPage > MAX_LINKS
    return (
      <>
        {pageRender(1)}
        {displayDivider && dividerRender()}
      </>
    )
  }

  const tail = () => {
    if (maxPage === 7) {
      return (
        <>
          {pageRender(maxPage)}
        </>
      )
    } else if (maxPage > 7) {
      return (
        <>
          {dividerRender()}
          {pageRender(maxPage)}
        </>
      )
    }
  }

  const body = () => {
    if (maxPage <= MAX_LINKS) {
      return displayLessPages()
    } else if (currentPageIsAtBeginning) {
      return displayFirstPages()
    } else if (currentPageIsAtEnd) {
      return displayLastPages()
    } else {
      return displayNearPages()
    }
  }

  const displayLessPages = () => {
    const pages = Array.from({ length: maxPage }, (_, i) => i + 1).filter((i) => ![1, MAX_LINKS].includes(i))
    return pages.map((page) => pageRender(page))
  }

  const displayLastPages = () => {
    const pages = Array.from({ length: MAX_LINKS - 2 }, (_, i) => i - (MAX_LINKS - 2)).map((i) => maxPage + i)
    return pages.map((page) => pageRender(page))
  }

  const displayFirstPages = () => {
    const pages = Array.from({ length: MAX_LINKS }, (_, i) => i + 1).filter((i) => ![1, MAX_LINKS].includes(i))
    return pages.map((page) => pageRender(page))
  }

  const displayNearPages = () => {
    const pages = [currentPage - 2, currentPage - 1, currentPage, currentPage + 1, currentPage + 2]
    return pages.map((page) => pageRender(page))
  }

  const pageRender = (page) => {
    let style = {}
    let className = ''
    if (page === currentPage) {
      style = { ...defaultPageStyle, ...selectionnedPageStyle }
      className = 'selectionned'
    } else {
      style = { ...defaultPageStyle, ...unselectionnedPageStyle }
      className = 'unselectionned'
    }
    return (
      <div className={className} style={style} onClick={() => onChange(page)}>
        {page}
      </div>
    )
  }

  const dividerRender = () => {
    return (
      <div style={{ ...defaultPageStyle, cursor: 'default' }}>
        ...
      </div>
    )
  }

  const pageMenu = () => {
    const pages = []
    pages.push(head())
    pages.push(body())
    pages.push(tail())
    return pages.flat()
  }

  const prevPage = () => {
    let style = {}
    let disabled = false
    let onClick = () => { }
    if (currentPage === 1) {
      style = { ...defaultPageStyle, cursor: 'default' }
      disabled = true
    } else {
      onClick = () => onChange(currentPage - 1)
      style = { ...defaultPageStyle, ...unselectionnedPageStyle }
    }
    return (
      <LeftOutlined className='unselectionned' style={style} onClick={onClick} disabled={disabled} />
    )
  }

  const nextPage = () => {
    let style = {}
    let disabled = false
    let onClick = () => { }
    if (currentPage === maxPage) {
      style = { ...defaultPageStyle, cursor: 'default' }
      disabled = true
    } else {
      onClick = () => onChange(currentPage + 1)
      style = { ...defaultPageStyle, ...unselectionnedPageStyle }
    }
    return (
      <RightOutlined className='unselectionned' style={style} onClick={onClick} disabled={disabled} />
    )
  }

  return (
    <div className='pagination-custom' style={{ display: 'flex', height: '30px', margin: '1em 0 2em 0' }}>
      {prevPage()}
      {pageMenu(currentPage, maxPage, onChange)}
      {nextPage()}
    </div>
  )
}
